import { Controller } from "@hotwired/stimulus"

// Web dashboard Highlights rail: a mouse can drag it sideways the way a finger
// swipes it on the phone. Touch and trackpads keep the browser's own scrolling;
// the click that ends a drag is swallowed so it does not open the strip.
const DRAG_SLOP_PX = 4

export default class extends Controller {
  connect() {
    this.onDown = this.down.bind(this)
    this.onMove = this.move.bind(this)
    this.onUp = this.up.bind(this)
    this.onClick = this.click.bind(this)
    this.onDragStart = (event) => event.preventDefault()
    this.element.addEventListener("pointerdown", this.onDown)
    this.element.addEventListener("click", this.onClick, true)
    // The strips are links: a native link drag would cancel the pointer and
    // leave the rail following the mouse with no button held.
    this.element.addEventListener("dragstart", this.onDragStart)
  }

  disconnect() {
    this.element.removeEventListener("pointerdown", this.onDown)
    this.element.removeEventListener("click", this.onClick, true)
    this.element.removeEventListener("dragstart", this.onDragStart)
    this.stopListening()
  }

  down(event) {
    if (event.pointerType !== "mouse" || event.button !== 0) return
    if (event.target.closest("button")) return
    this.startX = event.clientX
    this.startScroll = this.element.scrollLeft
    this.moved = false
    window.addEventListener("pointermove", this.onMove)
    window.addEventListener("pointerup", this.onUp)
    window.addEventListener("pointercancel", this.onUp)
  }

  move(event) {
    const dx = event.clientX - this.startX
    if (!this.moved && Math.abs(dx) < DRAG_SLOP_PX) return
    if (!this.moved) {
      this.moved = true
      this.element.classList.add("is-drag")
    }
    this.element.scrollLeft = this.startScroll - dx
  }

  up() {
    this.stopListening()
    this.element.classList.remove("is-drag")
  }

  click(event) {
    if (!this.moved) return
    event.preventDefault()
    event.stopPropagation()
    this.moved = false
  }

  stopListening() {
    window.removeEventListener("pointermove", this.onMove)
    window.removeEventListener("pointerup", this.onUp)
    window.removeEventListener("pointercancel", this.onUp)
  }
}
